module.exports = __webpack_public_path__ + "static/media/default-avatar.dc3d73d9.png";